import HelpFooterShell from "@src/components/help-footer-shell";
import classNames from "classnames";
import { Outlet } from "react-router-dom";

export default function ClientPortalLayout() {
  return (
    <HelpFooterShell footerClassName="bg-gray-100">
      <div className={classNames("w-full h-full", "flex")}>
        <Outlet />
      </div>
    </HelpFooterShell>
  );
}
